// src/api/intradayTrades.js (for example)
import axios from "../config/axiosConfig";

export const createIntradayTrade = async (payload) => {
  try {
    const res = await axios.post("/intraday-trades", payload);
    return res.data;
  } catch (err) {
    console.error("Intraday trade creation failed", err);
    throw err;
  }
};

// ✅ New: Close an intraday trade
export const closeIntradayTrade = async (tradeId) => {
  try {
    console.log(tradeId);
    const res = await axios.patch(`/intraday-trades/${tradeId}/close`);
    return res.status; // full trade object with exitPrice, realizedPnL, etc.
  } catch (err) {
    console.error("Closing intraday trade failed", err);
    throw err;
  }
};
